module.exports = __webpack_public_path__ + "media/images/samples/home/news/f1@2x-54885f2f8158628038b415f553da3c8c.png";